import Moment from 'moment-timezone';
import { extendMoment } from 'moment-range';

const moment = extendMoment(Moment);

export const dateFilterOptions = [
  {
    range: moment().range('day'),
    display: 'Today',
    name: 'today',
  },
  {
    range: moment().add(1, 'days').range('day'),
    display: 'Tomorrow',
    name: 'tomorrow',
  },
  { range: moment().range('week'), display: 'This week', name: 'thisWeek' },
  {
    range: moment().add(1, 'week').range('week'),
    display: 'Next week',
    name: 'nextWeek',
  },
  {
    range: moment().range('month'),
    display: 'This month',
    name: 'thisMonth',
  },
  {
    range: moment().add(1, 'month').range('month'),
    display: 'Next month',
    name: 'nextMonth',
  },
];
